module.exports = __webpack_public_path__ + "static/img/pico42.3cb5492.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico42.png
// module id = Gdcn
// module chunks = 0